import * as React from 'react';

const NavbarStripeSvg = props => (
  <svg
    id="stripe"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 500 143.1"
  >
    <polygon
      fill="#d1441e"
      className="cls-1"
      points="540.7 280.9 395.3 -137.9 329.3 -137.9 474.6 280.9 540.7 280.9"
    />
    <polygon
      fill="#d1441e"
      className="cls-1"
      points="428.3 280.9 283.1 -137.9 15.6 -137.9 160.8 280.9 428.3 280.9"
    />
    <polygon
      fill="#d1441e"
      className="cls-1"
      points="134 280.9 -11.3 -137.9 -44.9 -137.9 100.2 280.9 134 280.9"
    />
  </svg>
);

export default NavbarStripeSvg;
